import {call, put, takeLatest, select} from "redux-saga/effects";
import {
  createGroup,
  deleteGroup,
  editGroup,
  getGroups,
  getGroupsLabelValueAsync,
  listPermissions,
  listUser,
} from "../AsyncActions/group.async";
import * as actions from "../action.constants";
import {getCustomerUserProfile} from "../Selectors/users.selector";

function* groupRequest(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const response = yield call(getGroups, pageUrl);
    if (response) {
      yield put({
        type: actions.SAVE_GROUP_LIST,
        responsePayload: response?.data,
      });
    }
  } catch (e) {
    /* empty */
  }
}

function* getPermissionList() {
  try {
    const response = yield call(listPermissions);
    if (response?.data) {
      yield put({
        type: actions.SAVE_PERMISSION_LIST,
        responsePayload: response?.data?.data,
      });
    }
  } catch (e) {
    /* empty */
  }
}

function* getGroupsLabelValue() {
  try {
    const response = yield call(getGroupsLabelValueAsync);
    if (response?.data) {
      yield put({
        type: actions.STORE_GROUP_LABEL_VALUE_LIST,
        payload: response?.data?.data,
      });
    }
  } catch (e) {
    /* empty */
  }
}

function* getUsersList(action) {
  const {excludeMe = false} = action;
  const currentUser = yield select(getCustomerUserProfile);
  try {
    const response = yield call(listUser, {excludeMe, userId: currentUser.id});
    if (response?.data) {
      yield put({
        type: actions.SAVE_USER_LIST,
        responsePayload: response?.data?.data,
      });
    }
  } catch (e) {
    /* empty */
  }
}

function* deleteGroupRequest(action) {
  const {payload, callback = () => {}} = action;
  try {
    const response = yield call(deleteGroup, payload);
    if (response) {
      callback();
      yield call(groupRequest);
    }
  } catch (e) {
    return e;
  }
}

function* createGroupRequest(action) {
  const {payload, callback = () => {}} = action;

  try {
    const response = yield call(createGroup, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* editGroupRequest(action) {
  const {payload, callback = () => {}} = action;

  try {
    const response = yield call(editGroup, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

export function* groupSaga() {
  yield takeLatest(actions.REQUEST_GROUP_LIST_SAGA, groupRequest);
  yield takeLatest(actions.REQUEST_PERMISSION_LIST, getPermissionList);
  yield takeLatest(actions.REQUEST_GROUP_LABEL_VALUE_LIST, getGroupsLabelValue);
  yield takeLatest(actions.REQUEST_USER_LIST, getUsersList);
  yield takeLatest(actions.REQUEST_DELETE_GROUP_SAGA, deleteGroupRequest);
  yield takeLatest(actions.REQUEST_SEND_ADD_GROUP_DATA_SAGA, createGroupRequest);
  yield takeLatest(actions.REQUEST_SEND_EDIT_GROUP_DATA_SAGA, editGroupRequest);
}
